import React from 'react';
import { LINKS } from '../../constants/links';

const Logo = () => {
  return (
    <div className="header-left">
      <img 
        src="GLFR-White-100h.png" 
        alt="glfr logo" 
        className="header-logo" 
        onClick={() => window.location.href = LINKS.GLFR_HOME}
      />
    </div>
  );
};

export default Logo; 